export default __webpack_public_path__ + "img/icon03.1d4504eb.svg";